import { Link } from 'react-router-dom'

import { StatusScreen } from '@/components/status-screen/status-screen'
import { Button } from '@/components/ui/button'

interface PlaceholderProps {
  title: string
  /** Rota tablosundaki geliştirici notu; kullanıcıya gösterilmez. */
  description?: string
}

export function Placeholder({ title }: PlaceholderProps) {
  return (
    <StatusScreen
      variant="coming-soon"
      title={title}
      description="Bu sayfa yakında hazır olacak."
      actions={
        <Button asChild variant="outline">
          <Link to="/app">Ana ekrana dön</Link>
        </Button>
      }
    />
  )
}
